var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"advertisement-header"},[_c('div',{staticClass:"advertisement-header-text"},[_c('h3',[_vm._v("系统平台搭建")]),_c('p',[_vm._v("提供定制化的平台开发服务，根据需求打造功能丰富、高效的系统平台。")]),_c('div',{on:{"click":_vm.handleClick}},[_vm._v("发布信息")])])]),_c('common',{attrs:{"type":"4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }